import { Text } from "@radix-ui/themes";
import styles from "./TldrFormatter.module.scss";

export function TldrFormatter({ value }: { value: string }) {
  return (
    <Text
      size="1"
      color="gray"
      weight={"medium"}
      className={styles.TldrFormatter}
      highContrast
    >
      {value}
    </Text>
  );
}
